/**
 * @lines98/client/screens/profile-screen — Профиль как ЛИЧНЫЙ КАБИНЕТ-ВИТРИНА (v4,
 * owner-approved «один блок личности + inline-правка имени», 2026-06-21). ОДИН
 * вертикальный столбец по центру (НЕ 2 колонки нигде), сверху вниз: заголовок «Профиль»
 * (БЕЗ «?») → монеты+осколки → камни → ОДИН блок личности (имя ПОКАЗАНО РОВНО ОДИН РАЗ,
 * правка inline) → таблица режимов (скруглённая) → плашка ачивок (с футером раскрытия).
 * Серверный контракт — ADR-0019 (потребляем как есть).
 *
 * **v4-изменения (owner-approved после нескольких итераций):**
 *   (1) ОДИН блок личности, имя ОДИН раз, правка inline (паттерн LinkedIn inline-edit).
 *       Прежний дубль (шапка [имя+#тег+уровень] И отдельная плашка-аккаунт с полем ввода)
 *       УБРАН — теперь ОДИН `.profile-identity` с 3 состояниями:
 *         - Гость: текст «Войдите, чтобы сохранить прогресс» слева + кнопка «Войти» справа
 *           (`createPillButton` + `openLoginFlow`, тот же примитив рейла).
 *         - Вошёл, имя задано (DISPLAY-режим): [Имя #тег] (крупно, акцент) + [бейдж уровня] +
 *           [✎ «Изменить имя»]; XP под строкой. Клик ✎ → EDIT-режим НА МЕСТЕ (имя становится
 *           полем; текущее имя как редактируемое значение серым; «Сохранить»/«Отмена»). При
 *           вводе → транзиентная подсказка цены (сама исчезает). «Сохранить» → confirmDialog →
 *           changeDisplayName (1000, idempotency); <1000 → сообщение без списания.
 *         - Вошёл, имя НЕ задано (display_name NULL): сразу EDIT-режим, плейсхолдер «Придумайте
 *           имя», «Сохранить» — БЕСПЛАТНО, без подсказки-цены и без confirm; «Отмена» скрыта
 *           (нечего отменять — имени ещё нет).
 *       СЛОВО ВЕЗДЕ — «Имя» (никаких «ник»/«никнейм»): «Изменить имя», «Придумайте имя».
 *       a11y: ✎ aria-label; фокус в поле при входе в правку; Esc — отмена, Enter — сохранить.
 *       Имя в Профиле — РОВНО ОДИН РАЗ (дубль шапка/плашка убран).
 *   (2) Таблица режимов — СКРУГЛЁННЫЕ края (border-radius вернулся); первая колонка (названия)
 *       — ширина ПО КОНТЕНТУ (max-content, white-space:nowrap), числовые делят остаток
 *       (table-layout:auto).
 *   (3) Ачивки — ФУТЕР раскрытия (боковая каретка убрана): по центру на всю ширину «Показать
 *       все ▾» (свёрнуто) / «Свернуть ▴» (раскрыто); тап тоглит грид (1 ряд ↔ все), стрелка
 *       флипается. Значки фикс-размера (Δ0). Тап по значку → анкер-деталь (не сломан).
 *   (4) ЕДИНАЯ ШИРИНА: блок личности = таблица = плашка ачивок — одинаковой ширины на всех
 *       классах (общая центральная колонка → левый/правый край совпадают у всех трёх).
 *
 * **«Тонкая ветка» (CLAUDE.md «ствол → ветки», code-structure §1):** монтирует ОБЩИЕ
 * модули, задаёт только композицию/вид. Переиспользует (REUSE, НЕ дублирует):
 *   - Заголовок = `.screen-title` + `attachTitleFit` (паритет «Помощники»; БЕЗ «?»-popover).
 *   - Ресурсы = `mountCurrencyHud({showKarat:false})` + `mountGemPoolHud` (модули «Помощников»).
 *   - Блок личности = `playerDisplayParts` (имя+`#`-тег) + `createLevelBadge` + XP-бар; вход —
 *     `createPillButton(accent, LOGIN_ICON_SVG)` + `openLoginFlow()` (тот же примитив рейла).
 *   - Смена имени = `changeDisplayName` (services/meta-api — idempotency внутри) + `confirmDialog`
 *     (только повторная смена) + `NICKNAME_CHANGE_COST` config + на успехе `emitIdentityChanged`
 *     + ресинк `getMetaStateShared` (золото server-truth, локально НЕ списываем).
 *   - Таблица = `profileStats.modeStats` (имена из `mode-registry`, `averageScore` server-truth,
 *     honest-empty, фикс-порядок; «Доска дня» — отдельная строка; герой-колонка «Лучший счёт»;
 *     медаль на абсолютном рекорде).
 *   - Плашка ачивок = `createBadgeStrip` (грид icon-only значков фикс-размера) + ФУТЕР-кнопка
 *     раскрытия (флип грид 1 ряд ↔ все; стрелка ▾↔▴).
 *   - instant-hydration = `lib/meta-snapshot` → reconcile `getMetaStateShared`.
 *   - реактив входа/выхода = `onIdentityChanged` (lib/identity-events).
 *
 * **Server-truth (I-Prof-2):** экран — ПРОЕКЦИЯ `GET /meta/state`. Уровень/xp/ачивки/ресурсы/
 * таблица — серверная правда; клиент НЕ пересчитывает (средний счёт берётся готовым).
 * I-Prof-1: display-only, не входит в score/ранг/честные лидерборды.
 *
 * **Смена имени (I-Prof-3/4):** списание И смена `display_name` — атомарно на сервере; клиент
 * НЕ списывает локально, имя оптимистично НЕ меняет до verdict'а. Первая установка
 * (`isUnsetNick`/имя=«Игрок»/пуст) — БЕСПЛАТНО (БЕЗ warning/cost/confirm, поле сразу открыто,
 * кнопка «Сохранить»); повторная смена при ≥1000 → `confirmDialog` ДО мутации; при <1000 →
 * сообщение, без мутации. Анти-дубль: выхода-из-аккаунта на Профиле НЕТ (меню чипа рейла).
 *
 * Cross-references:
 *   - owner-approved направление v4 (2026-06-21): один блок личности + inline-правка.
 *   - ADR-0019 (server contract: per-mode stats + change-display-name + wasFirstSet).
 *   - @lines98/shared/util (playerDisplayParts); @lines98/shared/config/meta (NICKNAME_CHANGE_COST).
 *   - lib/{auth-flow,identity-events,currency-hud,meta-snapshot,mode-registry,title-fit}.
 *   - components/{pill-button,confirm-dialog,gem-pool-hud,level-badge,badge-strip,meta-icons}.
 *   - services/{identity,meta-api,meta-prefetch}; lib/nav-rail (LOGIN_ICON_SVG single source).
 *   - styles/profile.css (layout-plan + CSS-algebra в шапке файла).
 */

import '../styles/profile.css';

import { NICKNAME_CHANGE_COST } from '@lines98/shared/config/meta';
import { playerDisplayParts } from '@lines98/shared/util';

import { t, getLocale } from '../lib/i18n/index.js';
import { createBadgeStrip, type BadgeStripHandle } from '../components/badge-strip.js';
import { confirmDialog } from '../components/confirm-dialog.js';
import { mountGemPoolHud, type GemPoolHudHandle } from '../components/gem-pool-hud.js';
import { createLevelBadge, type LevelBadgeHandle } from '../components/level-badge.js';
import { ICON_GOLD } from '../components/meta-icons.js';
import { createPillButton } from '../components/pill-button.js';
import { openLoginFlow } from '../lib/auth-flow.js';
import { mountCurrencyHud, type CurrencyHudHandle } from '../lib/currency-hud.js';
import { formatRuNumber } from '../lib/format.js';
import { emitIdentityChanged, onIdentityChanged } from '../lib/identity-events.js';
import {
  canSaveName,
  NAME_MAX_CODEPOINTS,
  NAME_MIN_CODEPOINTS,
} from '../lib/profile-name-edit.js';
import {
  buildMetaSnapshot,
  loadMetaSnapshot,
  saveMetaSnapshot,
  type MetaSnapshot,
} from '../lib/meta-snapshot.js';
import { saveSeenAchievements } from '../lib/achievement-seen-badge.js';
import { mountCollapseSection } from '../lib/collapse-section.js';
import { emitMetaStateGranted } from '../lib/meta-state-events.js';
import { MODE_REGISTRY, modeLabel } from '../lib/mode-registry.js';
import type { ContentLang } from '@lines98/shared/config/seo';
import { LOGIN_ICON_SVG } from '../lib/nav-rail.js';
import { createValueGuard } from '../lib/reconcile-guard.js';
import { attachTitleFit } from '../lib/title-fit.js';
import { bootIdentity, getCurrent, isAuthed, update as updateIdentity } from '../services/identity.js';
import {
  changeDisplayName,
  type ProfileModeStat,
  type ProfileStats,
  type ProfileStatRowKey,
  type ProgressionState,
} from '../services/meta-api.js';
import { getMetaStateShared } from '../services/meta-prefetch.js';
import type { ScreenHandle } from './board-screen.js';

/**
 * Транзиентное предупреждение о платности (ТОЛЬКО повторная смена). Появляется на ввод,
 * сама исчезает. owner-verbatim 2026-06-21: «Изменить имя можно только за N монет.
 * Выбирайте внимательно.» Число — из config (NICKNAME_CHANGE_COST), не хардкод.
 */
// Геттер (не const): резолвится по активной локали в момент показа. Число — config.
const payWarningText = (): string =>
  t('game.profile.changeNamePaid', { cost: NICKNAME_CHANGE_COST });

/**
 * ПОСТОЯННОЕ предупреждение при ПЕРВОЙ установке имени (owner-directive 2026-06-21: «при
 * вводе имени не было предупреждения, что имя потом бесплатно не сменить»). Первый ввод
 * бесплатен, но единоразово — дальше смена платная. Показываем сразу (не транзиент), чтобы
 * игрок выбирал осознанно. Число — из config (NICKNAME_CHANGE_COST), не хардкод.
 */
const firstSetWarningText = (): string =>
  t('game.profile.changeNameFirstFree', { cost: NICKNAME_CHANGE_COST });

/** Тайминг авто-скрытия транзиентного предупреждения (мс) — «~3.5с бездействия». */
const PAY_WARNING_HIDE_MS = 3500;

/** Карандаш-глиф для ✎ «Изменить имя» (inline-SVG, currentColor — наследует цвет кнопки). */
const PENCIL_SVG = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 20h9"/><path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z"/></svg>`;

/** Шеврон ▾ для футера ачивок (флип на ▴ через CSS rotate по aria-expanded). currentColor. */
const ACH_CARET_SVG = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2"
  stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 9l6 6l6 -6"/></svg>`;

// Зеркало серверной DISPLAY_NAME-политики (длина 2..24 кодпойнта) — единый источник
// `lib/profile-name-edit` (NAME_MIN/NAME_MAX), не дублируем числа здесь (no-hardcode).

/** Пустая статистика (холодный заход без снимка) — таблица honest-empty по всем рядам. */
const EMPTY_STATS: ProfileStats = {
  gamesTotal: 0,
  dailyCount: 0,
  modesEverPlayed: 0,
  bestByMode: {},
  currentDailyStreak: 0,
  dailyRank: null,
  modeStats: {},
};

/**
 * Фикс-порядок строк таблицы режимов (AC-12: НЕ сортировать по активности): играбельные
 * режимы из `MODE_REGISTRY` (predict/classic/blind) + «Доска дня» 5-й строкой. Имена —
 * единый источник `MODE_REGISTRY` (daily — отдельная строка-режим). Locked/будущие
 * режимы НЕ включаются (honest-only).
 */
const TABLE_ROWS: readonly { key: ProfileStatRowKey }[] = (() => {
  const rows: { key: ProfileStatRowKey }[] = [];
  for (const e of MODE_REGISTRY) {
    if (e.mode && !e.locked) rows.push({ key: e.mode });
  }
  // «Доска дня» — 5-й строкой. Имена режимов и «Доска дня» резолвятся в renderTable
  // per-mount (modeLabel / t('game.profile.rowDaily')) — НЕ запекаются на import, чтобы
  // таблица следовала языку (фаза-ремонт на смену locale).
  rows.push({ key: 'daily' });
  return rows;
})();

/** Локализованное имя строки таблицы режимов (per-mount, follows active locale). */
function modeRowLabel(key: ProfileStatRowKey): string {
  if (key === 'daily') return t('game.profile.rowDaily');
  const entry = MODE_REGISTRY.find((e) => e.mode === key);
  return entry ? modeLabel(entry, getLocale() as ContentLang) : String(key);
}

/** Длина строки в кодпойнтах (а не UTF-16 units) — корректно для эмодзи/суррогатов. */
function codepointLength(s: string): number {
  return [...s].length;
}

/** Текущий «отображаемый» ник (или «Игрок» если не задан) — для сравнения «изменился ли». */
function currentNick(): string {
  const cur = getCurrent();
  const { name } = playerDisplayParts(cur?.displayName, cur?.playerId ?? '');
  return name;
}

/**
 * Считается ли текущий ник «не заданным» (первая установка → бесплатно, AC-8).
 *
 * Server-truth «первой установки» = `players.display_name IS NULL` (гейт
 * change-display-name.ts). Зеркалим РОВНО это: unset = displayName пуст/null. 'Игрок' —
 * лишь КЛИЕНТСКИЙ fallback ОТОБРАЖЕНИЯ (playerDisplayParts), в identity НЕ хранится и
 * сервером никогда не пишется, поэтому его проверять НЕЛЬЗЯ: иначе аккаунт с реальным
 * именем, чья identity ещё не реконсилена, ошибочно считался бы «не заданным» (free), а
 * сервер требовал бы 1000 (paid) — owner-bug 2026-06-21. Реконсиляция identity ←
 * server-truth `displayName` в load() гарантирует, что здесь значение = серверному.
 */
function isUnsetNick(): boolean {
  const cur = getCurrent();
  const raw = (cur?.displayName ?? '').trim();
  return raw.length === 0;
}

/** HTML-escape для текстовых позиций (имена режимов — config-канон, но дисциплина). */
function escapeHtml(s: string): string {
  return s.replace(/[&<>"]/g, (ch) =>
    ch === '&' ? '&amp;' : ch === '<' ? '&lt;' : ch === '>' ? '&gt;' : '&quot;',
  );
}

/**
 * Смонтировать Профиль-витрину. Загружает `GET /meta/state` (+ progression +
 * profileStats.modeStats), рендерит заголовок/ресурсы/идентичность/плашку аккаунта/
 * таблицу/полосу ачивок. Тонкая ветка — монтирует общие модули, задаёт только композицию.
 */
export function mountProfileScreen(host: HTMLElement): ScreenHandle {
  host.innerHTML = '';
  const root = document.createElement('div');
  // .screen-root — ствол-класс edge-clearance (safe-area-aware, global.css).
  root.className = 'profile-screen screen-root';
  // ОДИН вертикальный столбец (AC-1): header (заголовок + ресурсы) фиксирован (grid-row auto);
  // scroll(идентичность + плашка + таблица + ачивки) — bounded inner-scroll (1fr); статус — auto.
  root.innerHTML = `
    <header class="profile-header">
      <h2 class="profile-title screen-title">${t('game.profile.title')}</h2>
      <div class="profile-hud-host"></div>
      <div class="profile-gems-host"></div>
    </header>

    <div class="profile-scroll">
      <!-- ОДИН блок личности (v4): имя ПОКАЗАНО РОВНО ОДИН РАЗ, правка inline. 3 состояния
           рендерятся в .profile-identity-body через renderIdentity() по идентичности:
           гость → текст+«Войти»; вошёл+имя → [Имя #тег]+бейдж+✎; вошёл+нет имени → поле сразу.
           XP-линия — общая часть для залогиненного (под телом). -->
      <section class="profile-identity" aria-label="${t('game.profile.identityAria')}">
        <div class="profile-identity-body"></div>
        <div class="profile-xp" hidden>
          <div class="profile-xp-bar" role="progressbar" aria-label="${t('game.profile.xpAria')}"
               aria-valuemin="0" aria-valuemax="100">
            <div class="profile-xp-fill"></div>
          </div>
          <span class="profile-xp-label"></span>
        </div>
      </section>

      <!-- ОДНА таблица режимов: [Режим]·[Игр]·[Лучший счёт]·[Средний счёт]. Настоящая <table>
           на всех классах (AC-11). v4: первая колонка по контенту (max-content), числовые
           делят остаток (table-layout:auto); скруглённые края. -->
      <div class="profile-table-wrap">
        <table class="profile-modes-table" aria-label="${t('game.profile.tableAria')}">
          <thead>
            <tr>
              <th class="profile-mode-head-cell profile-mode-head-cell--name" scope="col">${t('game.profile.colMode')}</th>
              <th class="profile-mode-head-cell profile-mode-head-cell--muted" scope="col">${t('game.profile.colGames')}</th>
              <th class="profile-mode-head-cell profile-mode-head-cell--hero" scope="col">${t('game.profile.colBest')}</th>
              <th class="profile-mode-head-cell profile-mode-head-cell--muted" scope="col">${t('game.profile.colAvg')}</th>
            </tr>
          </thead>
          <tbody class="profile-modes-body"></tbody>
        </table>
      </div>

      <!-- Плашка ачивок — грид icon-only значков фикс-размера + ФУТЕР раскрытия (v4: боковая
           каретка убрана). Ширина = ширина таблицы (общая центральная колонка). -->
      <div class="profile-achievements"></div>
    </div>

    <div class="profile-state" role="status" aria-live="polite" hidden></div>
  `;
  host.appendChild(root);

  const identityBody = root.querySelector<HTMLElement>('.profile-identity-body')!;
  const xpWrap = root.querySelector<HTMLElement>('.profile-xp')!;
  const hudHost = root.querySelector<HTMLElement>('.profile-hud-host')!;
  const gemsHost = root.querySelector<HTMLElement>('.profile-gems-host')!;
  const xpBar = root.querySelector<HTMLElement>('.profile-xp-bar')!;
  const xpFill = root.querySelector<HTMLElement>('.profile-xp-fill')!;
  const xpLabel = root.querySelector<HTMLElement>('.profile-xp-label')!;
  const tableBody = root.querySelector<HTMLElement>('.profile-modes-body')!;
  const tableWrapEl = root.querySelector<HTMLElement>('.profile-table-wrap')!;
  const achHost = root.querySelector<HTMLElement>('.profile-achievements')!;
  const stateEl = root.querySelector<HTMLElement>('.profile-state')!;
  const scrollEl = root.querySelector<HTMLElement>('.profile-scroll')!;

  let destroyed = false;

  // --- Оптимистичный снимок (instant-hydration §3): тот же, что Мастерская/Гномы. ---
  const snapshot: MetaSnapshot | null = loadMetaSnapshot();
  if (!snapshot) root.classList.add('profile-screen--awaiting');

  // =========================================================================
  // Ресурсы: валюты (карат скрыт) + лента камней под ними (AC-3).
  // =========================================================================
  const hud: CurrencyHudHandle = mountCurrencyHud(hudHost, {
    showKarat: false,
    ...(snapshot ? { initial: { gold: snapshot.gold, shards: snapshot.shards } } : {}),
  });
  const gemHud: GemPoolHudHandle = mountGemPoolHud(gemsHost, {
    ...(snapshot ? { pool: snapshot.gemPool } : {}),
  });

  // =========================================================================
  // ОДИН блок личности (v4) — имя ПОКАЗАНО РОВНО ОДИН РАЗ, правка inline (LinkedIn pattern).
  // 3 состояния рендерятся в .profile-identity-body через renderIdentity():
  //   guest        — текст «Войдите, чтобы сохранить прогресс» + «Войти» (pill-кнопка рейла);
  //   authed/DISPLAY (имя задано)  — [Имя #тег] крупно + бейдж уровня + [✎ Изменить имя];
  //   authed/EDIT  (правка / имя не задано) — поле НА МЕСТЕ имени + «Сохранить»/«Отмена».
  // XP-линия (xpWrap) — общая для залогиненного, под телом; у гостя скрыта.
  // =========================================================================
  /** Текущее золото (server-truth снапшот) — гейт «<1000» перед мутацией (НЕ списание). */
  let currentGold: number = snapshot?.gold ?? 0;

  /** Уровень-бейдж — ОДИН экземпляр (переиспользуется между перерисовками DISPLAY). */
  const levelBadge: LevelBadgeHandle = createLevelBadge({
    level: snapshot?.progression.level ?? 1,
  });

  /** Флаг EDIT-режима (true = поле имени открыто). Переключается ✎ / Отмена / вход. */
  let editing = false;

  /**
   * Разрешён ли статус авторизации (П7, owner-bug 2026-06-22 «при F5 мелькает Войти →
   * профиль»). На холодном boot `mountProfileScreen` монтируется СИНХРОННО ДО резолва
   * `bootIdentity()` (IndexedDB async) → `isAuthed()` ещё false → без гейта рисуется guest-вид
   * («Войти»), затем флип на authed. Пока статус НЕ известен (false) — рисуем НЕЙТРАЛЬНЫЙ
   * скелет блока личности (НЕ guest), снимаем по резолву bootIdentity. Гость (реально не
   * залогинен) после резолва видит guest-вид как раньше (AC-7.3 — нет вечного скелета).
   */
  let identityResolved = false;

  /** Ссылки на узлы EDIT-режима (null вне правки). */
  let nameInput: HTMLInputElement | null = null;
  let saveBtn: HTMLButtonElement | null = null;
  let nameErrorEl: HTMLElement | null = null;
  /** Транзиентный warning — СОЗДАЁТСЯ на ввод (только повторная смена), УДАЛЯЕТСЯ при скрытии. */
  let payWarningEl: HTMLElement | null = null;
  let payWarningAnchor: HTMLElement | null = null;
  let payWarningTimer: number | null = null;

  function clearPayWarningTimer(): void {
    if (payWarningTimer !== null) {
      window.clearTimeout(payWarningTimer);
      payWarningTimer = null;
    }
  }

  /** Показать транзиентное предупреждение о платности (ТОЛЬКО повторная смена). Сама исчезает. */
  function flashPayWarning(): void {
    if (!payWarningAnchor) return;
    if (!payWarningEl) {
      payWarningEl = document.createElement('p');
      payWarningEl.className = 'profile-name-warning';
      payWarningEl.setAttribute('role', 'status');
      payWarningEl.textContent = payWarningText();
      payWarningAnchor.insertAdjacentElement('afterend', payWarningEl);
    }
    clearPayWarningTimer();
    payWarningTimer = window.setTimeout(() => {
      hidePayWarning();
    }, PAY_WARNING_HIDE_MS);
  }

  /** Скрыть = УДАЛИТЬ предупреждение из DOM (не висит постоянно). */
  function hidePayWarning(): void {
    clearPayWarningTimer();
    if (payWarningEl) {
      payWarningEl.remove();
      payWarningEl = null;
    }
  }

  function setNameError(message: string | null): void {
    if (!nameErrorEl) return;
    nameErrorEl.textContent = message ?? '';
    nameErrorEl.hidden = message === null;
  }

  /** Клиентская валидация имени (зеркало серверной длины 2..24 кодпойнта). */
  function validateName(name: string): string | null {
    const len = codepointLength(name);
    if (len < NAME_MIN_CODEPOINTS) return t('game.profile.errNameShort', { n: NAME_MIN_CODEPOINTS });
    if (len > NAME_MAX_CODEPOINTS) return t('game.profile.errNameLong', { n: NAME_MAX_CODEPOINTS });
    return null;
  }

  /** Применить server-truth verdict отказа смены имени к UI (сообщение под полем). */
  function applyChangeFailure(reason: string): void {
    const message =
      reason === 'insufficient_gold'
        ? t('game.profile.errNotEnough', { cost: formatRuNumber(NICKNAME_CHANGE_COST) })
        : reason === 'invalid_display_name'
          ? t('game.profile.errNameForbidden')
          : reason === 'unauthenticated'
            ? t('game.profile.errSessionExpired')
            : t('game.profile.errChangeFailed');
    setNameError(message);
  }

  /**
   * Поток нажатия «Сохранить». Первая установка (имя не задано) — БЕСПЛАТНО, БЕЗ confirm.
   * Повторная смена: <1000 → сообщение, без мутации; ≥1000 → confirm ДО мутации. На успехе —
   * emitIdentityChanged + ресинк баланса (server-truth, локально НЕ списываем) + выход из
   * EDIT в DISPLAY. Двойной клик безопасен (idempotency-key внутри changeDisplayName).
   */
  async function onSaveName(): Promise<void> {
    if (!nameInput || !saveBtn) return;
    const newName = nameInput.value.trim();
    setNameError(null);

    const invalid = validateName(newName);
    if (invalid) {
      setNameError(invalid);
      return;
    }

    const firstSet = isUnsetNick();

    // Повторная смена — платный путь: гейт по балансу + confirm ДО мутации.
    if (!firstSet) {
      if (currentGold < NICKNAME_CHANGE_COST) {
        setNameError(t('game.profile.errNotEnough', { cost: formatRuNumber(NICKNAME_CHANGE_COST) }));
        return;
      }
      const confirmed = await confirmDialog({
        title: t('game.profile.changeNameTitle'),
        message: t('game.profile.changeNameMsg', {
          name: newName,
          cost: formatRuNumber(NICKNAME_CHANGE_COST),
        }),
        confirmLabel: t('game.profile.changeNameConfirm'),
        cancelLabel: t('game.profile.changeNameCancel'),
      });
      if (destroyed) return;
      if (!confirmed) return; // отмена → монеты не списаны, имя не изменено.
    }

    // Анти-двойной-клик на время запроса (idempotency-key внутри хелпера = одно списание).
    saveBtn.disabled = true;
    const res = await changeDisplayName(newName);
    if (destroyed) return;

    if (!res.ok) {
      applyChangeFailure(res.reason);
      if (saveBtn) saveBtn.disabled = false;
      return;
    }

    // Успех: записать server-truth имя в локальную идентичность, единый сигнал, ресинк баланса.
    hidePayWarning();
    setNameError(null);
    const cur = getCurrent();
    if (cur) {
      await updateIdentity({
        playerId: cur.playerId,
        secretToken: cur.secretToken,
        displayName: res.displayName,
      });
      if (destroyed) return;
    }
    editing = false; // успех → выходим из правки в DISPLAY с новым именем.
    renderIdentity();
    emitIdentityChanged();
    void load(); // reconcile: новый баланс/имя из server-truth.
  }

  /** Войти в EDIT-режим (клик ✎ или первичная установка). */
  function enterEdit(): void {
    editing = true;
    renderIdentity();
  }

  /** Выйти из EDIT в DISPLAY без сохранения (Отмена / Esc). */
  function cancelEdit(): void {
    editing = false;
    hidePayWarning();
    renderIdentity();
  }

  /**
   * Построить НЕЙТРАЛЬНЫЙ скелет блока личности (П7): статус авторизации ещё не известен
   * (boot async). Мирроним геометрию DISPLAY-строки (имя+бейдж+✎), но содержимое скрыто
   * `visibility:hidden` (placeholder) → высота блока = высоте authed-вида (zero-CLS, AC-7.6),
   * при этом НИ guest-маркеров, НИ настоящего имени не видно (AC-7.1/7.2). XP-линия видна (как
   * у залогиненного) — секция .profile-identity той же высоты до и после резолва.
   */
  function buildIdentitySkeleton(): void {
    identityBody.classList.remove('profile-identity-body--guest');
    identityBody.classList.add('profile-identity-body--authed');
    identityBody.classList.add('profile-identity-body--skeleton');
    xpWrap.hidden = false;

    const line = document.createElement('div');
    line.className = 'profile-identity-line';
    // Placeholder-имя (nbsp, visibility:hidden) — даёт высоту строки без видимого текста.
    const nameRow = document.createElement('span');
    nameRow.className = 'profile-name-row';
    const nameEl = document.createElement('span');
    nameEl.className = 'profile-name';
    nameEl.textContent = ' ';
    nameRow.appendChild(nameEl);
    const levelHost = document.createElement('span');
    levelHost.className = 'profile-level-host';
    levelHost.appendChild(levelBadge.element);
    line.append(nameRow, levelHost);
    identityBody.appendChild(line);
  }

  /**
   * Построить DISPLAY-режим личности (имя задано, НЕ в правке): [Имя #тег] крупно + бейдж
   * уровня + [✎ «Изменить имя»]. Имя показано РОВНО ОДИН РАЗ.
   */
  function buildDisplay(): void {
    const cur = getCurrent();
    const { name, tag } = playerDisplayParts(cur?.displayName, cur?.playerId ?? '');

    const line = document.createElement('div');
    line.className = 'profile-identity-line';

    const nameRow = document.createElement('span');
    nameRow.className = 'profile-name-row';
    const nameEl = document.createElement('span');
    nameEl.className = 'profile-name';
    nameEl.textContent = name;
    const tagEl = document.createElement('span');
    tagEl.className = 'profile-tag';
    tagEl.textContent = `#${tag}`;
    nameRow.append(nameEl, tagEl);

    const levelHost = document.createElement('span');
    levelHost.className = 'profile-level-host';
    levelHost.appendChild(levelBadge.element);

    // ✎ «Изменить имя» — inline-триггер правки (a11y: aria-label + видимая подпись).
    const editBtn = document.createElement('button');
    editBtn.type = 'button';
    editBtn.className = 'profile-edit-name';
    editBtn.setAttribute('aria-label', t('game.profile.editNameAria'));
    editBtn.innerHTML = `<span class="profile-edit-name-glyph" aria-hidden="true">${PENCIL_SVG}</span><span class="profile-edit-name-label">${escapeHtml(t('game.profile.editNameAria'))}</span>`;
    editBtn.addEventListener('click', () => enterEdit());

    line.append(nameRow, levelHost, editBtn);
    identityBody.appendChild(line);
  }

  /**
   * Построить EDIT-режим личности (правка / имя не задано): поле НА МЕСТЕ имени + «Сохранить»
   * + «Отмена» (Отмена скрыта при первичной установке — нечего отменять). Первичная установка
   * → плейсхолдер «Придумайте имя», БЕЗ цены/confirm; повторная смена → транзиент-warning.
   * a11y: фокус в поле, Esc — отмена, Enter — сохранить.
   */
  function buildEdit(): void {
    const firstSet = isUnsetNick();

    const row = document.createElement('div');
    row.className = 'profile-name-edit-row';

    // Группа «поле + действия» в одной строке (поле слева, кнопки справа).
    const fieldGroup = document.createElement('div');
    fieldGroup.className = 'profile-name-field-group';

    const input = document.createElement('input');
    input.type = 'text';
    input.className = 'profile-name-input';
    input.id = 'profile-name-input';
    input.maxLength = NAME_MAX_CODEPOINTS;
    input.autocomplete = 'off';
    input.spellcheck = false;
    input.setAttribute(
      'aria-label',
      firstSet ? t('game.profile.nicknamePlaceholder') : t('game.profile.editNameAria'),
    );
    if (firstSet) {
      // Первичная установка: поле пустое + плейсхолдер «Придумайте имя» (серым).
      input.placeholder = t('game.profile.nicknamePlaceholder');
    } else {
      // Правка: текущее имя как редактируемое значение СЕРЫМ, пока не правили (CSS .is-pristine
      // → --ink-soft; на первый input снимаем pristine → текст становится --ink).
      input.value = currentNick();
      input.classList.add('profile-name-input--pristine');
    }
    fieldGroup.appendChild(input);

    // Действия: «Сохранить» + (повторная смена) метка стоимости + «Отмена».
    const action = document.createElement('div');
    action.className = 'profile-name-action';

    const save = document.createElement('button');
    save.type = 'button';
    save.className = 'btn profile-save-name';
    save.textContent = t('game.profile.btnSave');
    save.addEventListener('click', () => {
      void onSaveName();
    });
    action.appendChild(save);

    // Метка стоимости (КРУПНАЯ монета + число) — ТОЛЬКО повторная смена (firstSet → бесплатно).
    if (!firstSet) {
      const cost = document.createElement('span');
      cost.className = 'profile-name-cost';
      cost.innerHTML = `${ICON_GOLD}<span class="profile-name-cost-num">${NICKNAME_CHANGE_COST}</span>`;
      cost.setAttribute('aria-label', t('game.profile.changeCostLabel', { cost: NICKNAME_CHANGE_COST }));
      action.appendChild(cost);
    }

    // «Отмена» — выход из правки без сохранения. Скрыта при первичной установке (нечего
    // отменять — имени ещё нет, поле должно остаться открытым).
    if (!firstSet) {
      const cancel = document.createElement('button');
      cancel.type = 'button';
      cancel.className = 'btn profile-cancel-name';
      cancel.textContent = t('game.profile.btnCancel');
      cancel.addEventListener('click', () => cancelEdit());
      action.appendChild(cancel);
    }

    fieldGroup.appendChild(action);
    row.appendChild(fieldGroup);

    // ПЕРВАЯ установка: ПОСТОЯННОЕ предупреждение «бесплатно только один раз» (owner-directive
    // 2026-06-21) — видно сразу под полем, чтобы игрок выбирал осознанно. Повторная смена —
    // НЕ здесь (там транзиент-warning о платности на ввод).
    if (firstSet) {
      const firstHint = document.createElement('p');
      firstHint.className = 'profile-name-firsthint';
      firstHint.textContent = firstSetWarningText();
      row.appendChild(firstHint);
    }

    const error = document.createElement('p');
    error.className = 'profile-name-error';
    error.setAttribute('role', 'alert');
    error.hidden = true;

    identityBody.append(row, error);

    nameInput = input;
    saveBtn = save;
    payWarningAnchor = row;
    nameErrorEl = error;

    // Реактивный disabled «Сохранить» (П10, AC-10.1..10.4): кнопка неактивна, пока введённое
    // имя пустое ИЛИ == текущему ИЛИ вне длины — критерий из единого pure-предиката canSaveName
    // (один источник для клика и Enter-guard, нет дрейфа). aria-disabled синхронен с disabled.
    const syncSaveEnabled = (): void => {
      const ok = canSaveName({
        value: input.value,
        currentName: firstSet ? null : currentNick(),
        isUnset: firstSet,
      });
      save.disabled = !ok;
      save.setAttribute('aria-disabled', ok ? 'false' : 'true');
    };
    syncSaveEnabled(); // начальное состояние: pristine == текущему / пусто → disabled

    // Ввод: снять pristine (текущее имя перестаёт быть «серым значением»); очистить ошибку;
    // пересчитать disabled «Сохранить» (реактивно); транзиент-warning о платности (повторная).
    input.addEventListener('input', () => {
      input.classList.remove('profile-name-input--pristine');
      setNameError(null);
      syncSaveEnabled();
      if (!firstSet) flashPayWarning();
    });
    // Enter — сохранить ТОЛЬКО если разрешено (AC-10.6: Enter при disabled-условии = no-op,
    // как и клик); Esc — отмена (только повторная смена; при firstSet отмены нет).
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (!save.disabled) void onSaveName();
      } else if (e.key === 'Escape' && !firstSet) {
        e.preventDefault();
        cancelEdit();
      }
    });

    // Фокус в поле при входе в правку (a11y). На повторной смене — выделить весь текст, чтобы
    // правка/замена была сразу удобна.
    requestAnimationFrame(() => {
      if (destroyed) return;
      input.focus();
      if (!firstSet) input.select();
    });
  }

  /**
   * Перерисовать блок личности под текущее состояние идентичности + флаг editing.
   *   Гость       — текст «Войдите, чтобы сохранить прогресс» + «Войти» (НЕ во всю ширину).
   *   Залогинен, имя НЕ задано  — EDIT (поле сразу открыто, «Придумайте имя», бесплатно).
   *   Залогинен, имя задано, !editing — DISPLAY ([Имя #тег] + бейдж + ✎).
   *   Залогинен, editing        — EDIT (поле на месте имени, «Сохранить»/«Отмена»).
   */
  function renderIdentity(): void {
    hidePayWarning();
    identityBody.innerHTML = '';
    nameInput = null;
    saveBtn = null;
    payWarningAnchor = null;
    nameErrorEl = null;
    clearPayWarningTimer();
    identityBody.classList.remove('profile-identity-body--skeleton');

    // Статус авторизации ещё не известен (boot async, П7): нейтральный скелет блока личности
    // вместо guest-вида (AC-7.1/7.2 — НЕ показываем «Войти» ни на кадр при сохранённой сессии).
    // Геометрия скелета = DISPLAY-строке (имя+бейдж) → нет layout-shift при флипе (AC-7.6).
    if (!identityResolved) {
      buildIdentitySkeleton();
      return;
    }

    if (!isAuthed()) {
      // --- Гость: подсказка + «Войти» (тот же примитив рейла; НЕ во всю ширину). ---
      identityBody.classList.add('profile-identity-body--guest');
      identityBody.classList.remove('profile-identity-body--authed');
      xpWrap.hidden = true;
      const guest = document.createElement('div');
      guest.className = 'profile-guest';
      const text = document.createElement('p');
      text.className = 'profile-guest-text';
      text.textContent = t('game.profile.guestPrompt');
      const pill = createPillButton({
        icon: LOGIN_ICON_SVG,
        label: t('game.profile.btnLogin'),
        variant: 'accent',
        className: 'profile-login-pill',
        onClick: () => openLoginFlow(),
      });
      guest.append(text, pill.element);
      identityBody.appendChild(guest);
      return;
    }

    // --- Залогинен: XP-линия видна; тело — DISPLAY или EDIT. ---
    identityBody.classList.remove('profile-identity-body--guest');
    identityBody.classList.add('profile-identity-body--authed');
    xpWrap.hidden = false;

    // Имя не задано → всегда EDIT (поле сразу, бесплатно). Иначе DISPLAY/EDIT по флагу editing.
    if (isUnsetNick() || editing) {
      buildEdit();
    } else {
      buildDisplay();
    }
  }

  // --- Idempotent XP-бар (instant-hydration §3 — без скачка). ---
  const xpRatioGuard = createValueGuard<number>();
  const xpLabelGuard = createValueGuard<string>();
  let xpFirstApply = true;

  function renderXp(level: number, xpIntoLevel: number, xpForLevel: number, xpToNext: number): void {
    levelBadge.update({ level });
    const ratio = xpForLevel > 0 ? Math.min(1, Math.max(0, xpIntoLevel / xpForLevel)) : 0;
    if (xpRatioGuard.changed(ratio)) {
      if (xpFirstApply) {
        xpFill.classList.add('profile-xp-fill--instant');
        xpFill.style.transform = `scaleX(${ratio})`;
        xpFirstApply = false;
        requestAnimationFrame(() => {
          if (!destroyed) xpFill.classList.remove('profile-xp-fill--instant');
        });
      } else {
        xpFill.style.transform = `scaleX(${ratio})`;
      }
      xpBar.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
    }
    const label =
      xpToNext > 0
        ? t('game.profile.xpToNext', { next: level + 1, xp: formatRuNumber(xpToNext) })
        : t('game.profile.xpMaxCurve', { level });
    if (xpLabelGuard.changed(label)) xpLabel.textContent = label;
  }

  renderIdentity();

  // =========================================================================
  // Таблица режимов — ОДНА настоящая <table> (AC-11), фикс-порядок (AC-12). Вид — РОВНО как
  // таблица лидерборда (owner-directive 2026-06-21): БЕЗ выделенных строк (медаль 🥇 рекорда
  // УБРАНА), колонка «Лучший счёт» = акцент (как счёт в лидерборде), скругление --r-sm.
  // =========================================================================
  /** Один ряд таблицы (или honest-empty, если режим не сыгран). Все ряды единообразны. */
  function renderTableRow(
    label: string,
    key: ProfileStatRowKey,
    stat: ProfileModeStat | undefined,
  ): string {
    // Числа таблицы — БЕЗ разрядных разделителей (компактные цифры; tabular-nums держит
    // выравнивание). Средний — server-truth averageScore КАК ЕСТЬ (клиент НЕ делит).
    // Прочерк «нет данных» = ФИГУРНОЕ ТИРЕ U+2012 (‒), а НЕ em-dash (—): figure dash имеет
    // ширину цифры и right-align'ится РОВНО по правой линии цифр/заголовка (owner-bug
    // 2026-06-21: em-dash центрирован в широком advance → визуально стоял левее цифр).
    const games = stat ? String(stat.gamesCount) : '0';
    const best = stat ? String(stat.bestScore) : '‒';
    const avg = stat ? String(stat.averageScore) : '‒';
    return `
      <tr class="profile-mode-row" data-mode="${key}">
        <th scope="row" class="profile-mode-name">${escapeHtml(label)}</th>
        <td class="profile-mode-num profile-mode-num--muted">${games}</td>
        <td class="profile-mode-num profile-mode-num--hero"><span class="profile-mode-best">${best}</span></td>
        <td class="profile-mode-num profile-mode-num--muted">${avg}</td>
      </tr>
    `;
  }

  function renderTable(stats: ProfileStats): void {
    tableBody.innerHTML = TABLE_ROWS.map((r) =>
      // Имя режима/«Доска дня» резолвится per-mount (modeRowLabel) → следует языку.
      renderTableRow(modeRowLabel(r.key), r.key, stats.modeStats[r.key]),
    ).join('');
  }

  // =========================================================================
  // Плашка ачивок (v4 п.3) — грид icon-only значков фикс-размера (badge-strip) + ФУТЕР-кнопка
  // раскрытия (боковая каретка УБРАНА). Экран = тонкая ветка: монтирует badge-strip-грид +
  // футер-кнопку, тоглит класс `--open` на контейнере .profile-achievements (CSS сворачивает
  // грид до 1 ряда ↔ все ряды). Размер значка ИНВАРИАНТЕН к состоянию. Тап по значку →
  // анкер-деталь (внутри badge-strip — НЕ сломан).
  // =========================================================================
  const badgeStrip: BadgeStripHandle = createBadgeStrip({
    unlockedIds: new Set(snapshot?.progression.achievementIds ?? []),
    // ГРАНИЦА облака-детали = ТАБЛИЦА (owner-directive 2026-06-21: «плашка не выезжает за
    // размер таблицы»). Свежий rect на каждое открытие (скролл/ресайз учтены).
    getBoundary: () => tableWrapEl.getBoundingClientRect(),
  });
  achHost.appendChild(badgeStrip.element);

  // ФУТЕР-кнопка раскрытия — по центру, на всю ширину плашки, под гридом. «Показать все ▾»
  // (свёрнуто) / «Свернуть ▴» (раскрыто); стрелка флипается по aria-expanded (CSS rotate).
  let achOpen = false;
  const achToggle = document.createElement('button');
  achToggle.type = 'button';
  achToggle.className = 'profile-ach-toggle';
  achToggle.setAttribute('aria-expanded', 'false');
  const achToggleLabel = document.createElement('span');
  achToggleLabel.className = 'profile-ach-toggle-label';
  const achToggleCaret = document.createElement('span');
  achToggleCaret.className = 'profile-ach-toggle-caret';
  achToggleCaret.setAttribute('aria-hidden', 'true');
  achToggleCaret.innerHTML = ACH_CARET_SVG;
  achToggle.append(achToggleLabel, achToggleCaret);

  // Аккордеон-по-высоте: ПЛАВНОЕ раскрытие/свёртка грида значков по ИЗМЕРЕННОЙ высоте
  // (lib/collapse-section — ствол). Прежний CSS-приём `max-height: none` при --open НЕ
  // анимировался (CSS не анимирует переход в/из none) → раскрытие снапало рывком, реверстка
  // соседей толкала таблицу (owner-bug 2026-06-24). Модуль гонит max-height px↔px симметрично,
  // collapsed-высоту (1 ряд) держит CSS-формула .badge-strip-grid (размер ветки), expanded —
  // измеренный scrollHeight (без капа-константы §0.G.5). Класс `--open` остаётся как
  // визуальный маркер состояния (тест/каретка/overflow) — но высоту теперь ведёт JS.
  const achCollapse = mountCollapseSection({ target: badgeStrip.element, initialOpen: false });

  function syncAchToggle(): void {
    achToggleLabel.textContent = achOpen ? t('game.profile.collapse') : t('game.profile.showAll');
    achToggle.setAttribute('aria-expanded', achOpen ? 'true' : 'false');
    achHost.classList.toggle('profile-achievements--open', achOpen);
  }
  achToggle.addEventListener('click', () => {
    achOpen = !achOpen;
    syncAchToggle();
    // Анимировать высоту ПОСЛЕ переключения класса (--open снимает overflow-clip в CSS на
    // финале; collapse-section ведёт px-переход, чтобы кадры были плавными в обе стороны).
    if (achOpen) achCollapse.open();
    else achCollapse.close();
  });
  syncAchToggle();
  achHost.appendChild(achToggle);

  const titleFit = attachTitleFit(root);

  // =========================================================================
  // Загрузка / гидрация / reconcile.
  // =========================================================================
  function setScreenState(message: string | null): void {
    if (!message) {
      stateEl.hidden = true;
      stateEl.textContent = '';
      scrollEl.hidden = false;
      return;
    }
    stateEl.hidden = false;
    stateEl.textContent = message;
    scrollEl.hidden = true;
  }

  function renderLevel(p: ProgressionState): void {
    renderXp(p.level, p.xpIntoLevel, p.xpForLevel, p.xpToNext);
  }

  /** Мгновенная гидрация из СНИМКА при mount (instant-hydration §3). */
  function hydrateFromCache(snap: MetaSnapshot): void {
    const pr = snap.progression;
    renderXp(pr.level, pr.xpIntoLevel, pr.xpForLevel, pr.xpToNext);
    badgeStrip.update(new Set(pr.achievementIds));
    renderTable(snap.profileStats);
    gemHud.setPool(snap.gemPool);
    currentGold = snap.gold;
    // Заход на Профиль = игрок «посмотрел» → seen := open (сброс точки рейла «есть новые
    // достижения», AC-8, fe-achievement-result-window). Эмитим meta-state seam → рейл
    // пересчитает точку Профиля МГНОВЕННО при mount (не ждём reconcile). seen — per-player
    // через снимок-ствол (lib/achievement-seen-badge), source open-set = снимок (server-truth).
    markAchievementsSeen(pr.achievementIds);
  }

  /**
   * Сброс точки «есть новые достижения» на нав-пункте «Профиль» (AC-8): seen := текущий
   * open-set + эмит meta-state seam, чтобы рейл (app.ts refreshProfileBadge) пересчитал и
   * снял точку. По образцу gnomes-screen.resetBadge. Display-only (на мету не влияет).
   */
  function markAchievementsSeen(openIds: readonly string[]): void {
    saveSeenAchievements(openIds);
    // Рейл сравнивает open vs seen и снимает точку; granted-число — server-truth из снимка
    // (тот же seam, что гномы; achievement-точка читает open-set отдельно в app.ts).
    emitMetaStateGranted(loadMetaSnapshot()?.gnomeUnlocksGranted ?? 0);
  }

  /**
   * Загрузить server-truth и перерисовать всё (reuse boot-префетч getMetaStateShared).
   *
   * **Фикс бага «зависает на ‘Готовим профиль…’ при обновлении» (тикет fe-profile-v3 Баг
   * load):** на холодном заходе/refresh `mountProfileScreen` монтируется СИНХРОННО из
   * `mountApp`, ДО того как `bootIdentity()` зарезолвится (загрузка из IndexedDB / mint
   * анонима — асинхронны). Без гейта первый `load()` слал `GET /meta/state` БЕЗ Bearer
   * (identity ещё не готова) → 401 → `unauthenticated` → экран застревал в статусе и сам не
   * повторял (recovery через onIdentityChanged гонился с уже-летящим 401-полётом
   * getMetaStateShared и переиспользовал его stale-результат). ФИКС: ДОЖДАТЬСЯ готовности
   * идентичности (`await bootIdentity()`) ПЕРЕД fetch'ем — bootIdentity идемпотентен (общий
   * промис), резолвится к identity (аноним/загруженный), после чего Bearer гарантированно
   * прикладывается api-client'ом. Так Профиль НИКОГДА не стартует pre-bearer полёт → нет
   * 401-гонки → экран сам поднимается без ручного переключения рейла. Instant-hydration
   * (снимок) не затронут: кэш-показ идёт синхронно выше, это лишь server-truth дотягивание.
   */
  async function load(): Promise<void> {
    // Гейт на готовность сессии (Bearer) — иначе холодный refresh ловит 401 и залипает.
    // Идемпотентно: вернёт уже готовую identity мгновенно на повторных заходах.
    await bootIdentity();
    if (destroyed) return;
    // Статус авторизации теперь известен (П7): снять скелет → корректный guest/authed-вид.
    // НЕ во время ручной правки (editing) — чтобы не дёргать открытое поле.
    if (!identityResolved) {
      identityResolved = true;
      if (!editing) renderIdentity();
    }
    const res = await getMetaStateShared();
    if (destroyed) return;
    if (!res.ok) {
      root.classList.remove('profile-screen--awaiting');
      if (res.error === 'unauthenticated') {
        setScreenState(t('game.profile.loadingState'));
      } else {
        setScreenState(t('game.profile.loadError'));
      }
      return;
    }
    setScreenState(null);
    root.classList.remove('profile-screen--awaiting');

    hud.setBalances({ gold: res.gold, shards: res.shards });
    gemHud.setPool(res.gemPool);
    currentGold = res.gold;
    renderLevel(res.progression);
    const serverAchievementIds = res.progression.achievements.map((a) => a.achievementId);
    badgeStrip.update(new Set(serverAchievementIds));
    renderTable(res.profileStats);
    // server-truth open-set прилетел → seen := open (точка рейла снята по реальным данным,
    // AC-8). snapshot ниже сохраняется тем же res → seen и снимок консистентны.
    markAchievementsSeen(serverAchievementIds);
    // РЕКОНСИЛЯЦИЯ ИМЕНИ: identity ← server-truth `res.displayName` (owner-bug 2026-06-21).
    // Stale/legacy identity (старый localStorage без displayName, или не реконсиленная после
    // логина) показывала «придумайте имя» (free), а сервер требовал 1000 (paid) — рассинхрон.
    // Подтягиваем серверное имя в identity ПЕРЕД renderIdentity → isUnsetNick = серверному.
    // Пишем только при расхождении (без лишних identity-событий). НЕ во время ручной правки
    // (editing) — чтобы не дёргать открытое поле. updateIdentity идемпотентен.
    //
    // FORWARD-COMPAT (2026-06-22): НЕ затираем известное локальное имя серверным `null`.
    // `res.displayName = body.display_name ?? null` (meta-api): stale-/неполный server-ответ
    // без поля `display_name` даёт null — это «поле не прислано», а НЕ «имя очищено». Раньше
    // безусловная реконсиляция в таком случае стирала валидное локальное имя → залогиненный
    // с именем ошибочно падал в first-set «придумайте имя». Reconcile ТОЛЬКО когда сервер дал
    // НЕПУСТОЕ имя, отличное от локального (исходный сценарий owner-bug — server-HAS-name).
    if (!editing) {
      const curId = getCurrent();
      const serverName = res.displayName;
      if (curId && serverName != null && (curId.displayName ?? null) !== serverName) {
        await updateIdentity({
          playerId: curId.playerId,
          secretToken: curId.secretToken,
          displayName: serverName,
        });
        if (destroyed) return;
      }
    }
    // Перерисовать DISPLAY с server-truth именем — но НЕ во время правки (иначе затрём поле).
    if (!editing) renderIdentity();

    saveMetaSnapshot(buildMetaSnapshot(res));
  }

  /** Reconcile после смены идентичности (вход/выход/смена имени) — единый сигнал. */
  function reloadAfterIdentityChange(): void {
    editing = false; // смена аккаунта сбрасывает незавершённую правку.
    // Сигнал идентичности приходит ПОСЛЕ резолва bootIdentity (main.ts emitIdentityChanged) —
    // статус авторизации известен (П7): снять скелет, рисуем корректный guest/authed-вид.
    identityResolved = true;
    renderIdentity();
    const snap = loadMetaSnapshot();
    if (snap) {
      root.classList.remove('profile-screen--awaiting');
      hydrateFromCache(snap);
    } else {
      root.classList.add('profile-screen--awaiting');
    }
    void load();
  }

  const unsubscribeIdentity = onIdentityChanged(reloadAfterIdentityChange);

  // Мгновенная кэш-гидрация (если снимок есть). Иначе скелет первого захода + пустая таблица.
  if (snapshot) hydrateFromCache(snapshot);
  else renderTable(EMPTY_STATS);

  void load();

  return {
    unmount(): void {
      destroyed = true;
      clearPayWarningTimer();
      unsubscribeIdentity();
      titleFit.detach();
      hud.unmount();
      gemHud.unmount();
      achCollapse.detach();
      badgeStrip.destroy();
      host.innerHTML = '';
    },
  };
}
